import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '../shared/shared.module';
import { NgxDaterangepickerMd } from 'ngx-daterangepicker-material';
import { HomeLayoutRoutingModule } from './home-layout-routing.module';
import { HotelLayoutOneComponent } from './hotel-layout-one/hotel-layout-one.component';
import { HotelLayoutTwoComponent } from './hotel-layout-two/hotel-layout-two.component';

import { register } from 'swiper/element/bundle';
register();
@NgModule({
  declarations: [HotelLayoutOneComponent, HotelLayoutTwoComponent],
  imports: [
    CommonModule,
    SharedModule,
    NgxDaterangepickerMd.forRoot(),
    HomeLayoutRoutingModule
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class HotelLayoutModule {
  constructor() {}
}
